










































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { ResumoDesfazerCarga, ResumoDesfazerRepasse } from '@/types/interfaces/ResumoDesfazerCarga'

@Component
export default class ModalDesfazerCarga extends Vue {
  @Prop() visible: boolean
  @Prop() importacaoArquivoId: string

  readonly justificativaTamanhoMaximo: number = 1000

  readonly headers: object[] = [
    { text: 'Grupo de repasse', value: 'grupoRepasseNome', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false },
    { text: 'Empresa médica', value: 'empresaMedicaNome', sortable: false },
    { text: 'Situação', value: 'situacao', sortable: false },
    { text: 'Itens', value: 'quantidadeItens', align: 'center', sortable: false },
    { text: 'Valor', value: 'valorItens', align: 'right', sortable: false },
    { text: 'Impedimento', value: 'motivoBloqueio', sortable: false },
  ]

  show: boolean = false
  isCarregando: boolean = false
  loadingDesfazer: boolean = false
  justificativa: string = ''
  justificativaErro: string = ''
  erroResumo: string = ''
  resumo: ResumoDesfazerCarga | null = null

  get hasResumo() {
    return this.resumo !== null
  }

  // A checagem e feita sobre this.resumo, e nao sobre hasResumo: o compilador nao estreita o tipo
  // atraves de um getter, e a propriedade e anulavel ate o resumo carregar.
  get hasRepasses() {
    return this.resumo !== null && this.resumo.repasses.length > 0
  }

  // O backend manda: o impedimento vem do resumo, o front apenas renderiza.
  get hasImpedimento() {
    return this.resumo !== null && this.resumo.podeDesfazer === false
  }

  get isConfirmarDesabilitado() {
    return (
      this.isCarregando
      || this.loadingDesfazer
      || this.hasResumo === false
      || this.hasImpedimento
    )
  }

  @Watch('visible')
  onVisibilityChange(visible: boolean) {
    this.show = visible

    if (visible) {
      this.resetarEstado()
      this.loadResumo()
    }
  }

  close() {
    this.$emit('close')
  }

  resetarEstado() {
    this.justificativa = ''
    this.justificativaErro = ''
    this.erroResumo = ''
    this.resumo = null
  }

  async loadResumo() {
    this.isCarregando = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getResumoDesfazerCarga(
      this.importacaoArquivoId,
    )

    if (response.success) {
      this.resumo = response.data
    } else {
      this.erroResumo = response.message || 'Não foi possível carregar o resumo da carga.'
    }

    this.isCarregando = false
  }

  async desfazerCarga() {
    if (this.loadingDesfazer || this.isJustificativaInvalida()) {
      return
    }

    this.loadingDesfazer = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.desfazerRepasse(
      this.importacaoArquivoId,
      { justificativa: this.justificativa.trim() },
    )

    this.loadingDesfazer = false

    if (!response.success) {
      EventBus.$emit(
        'setSnackbar',
        getSnackbarMessage(response.message || 'Erro ao desfazer a carga.', 'error'),
      )

      return
    }

    EventBus.$emit(
      'setSnackbar',
      getSnackbarMessage('Carga desfeita com sucesso.', 'success'),
    )

    this.$emit('desfeito', response.data)
    this.close()
  }

  // Obrigatoriedade de campo e experiencia imediata: validacao de UX, nao regra de negocio.
  isJustificativaInvalida() {
    if (this.justificativa.trim().length === 0) {
      this.justificativaErro = 'Informe a justificativa para desfazer a carga.'

      return true
    }

    this.justificativaErro = ''

    return false
  }

  getRepasseRowClasses(repasse: ResumoDesfazerRepasse) {
    return repasse.podeDesfazer ? '' : 'modal-desfazer-carga__linha--bloqueada'
  }

  formatarValor(valor: number) {
    return (valor || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    })
  }
}
